import React, { ReactElement, useState } from 'react'
import { Button, ButtonGroup, Menu, MenuItem } from '@mui/material'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import { AccreditationStatus } from '../../shared-types'

type StatusOption = {
  value: AccreditationStatus
  label: string
}

let statusOptions: StatusOption[] = [
  { value: 'Draft', label: 'Create as Draft' },
  { value: 'Submitted', label: 'Create & Submit' },
  { value: 'Approved', label: 'Create as Approved' },
]

type StatusDropdownButtonProps = {
  selectedStatus: AccreditationStatus
  onStatusChange: (status: AccreditationStatus) => void
  onSubmit: () => void
}

export let StatusDropdownButton = ({
  selectedStatus,
  onStatusChange,
  onSubmit,
}: StatusDropdownButtonProps): ReactElement => {
  let [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)

  return (
    <>
      <ButtonGroup variant="contained">
        <Button onClick={onSubmit}>
          {statusOptions.find((opt) => opt.value === selectedStatus)?.label}
        </Button>
        <Button
          size="small"
          onClick={(e) => setAnchorEl(e.currentTarget)}
          aria-label="select create status"
        >
          <ArrowDropDownIcon />
        </Button>
      </ButtonGroup>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
      >
        {statusOptions.map((option) => (
          <MenuItem
            key={option.value}
            selected={option.value === selectedStatus}
            onClick={() => {
              onStatusChange(option.value)
              setAnchorEl(null)
            }}
          >
            {option.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  )
}
